module.exports = __webpack_public_path__ + "img/unsub-logo.ae5b1dab.png";